import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {ReceivablesBalanceNote} from "../../../../shared/interface/receivables-balance";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-receivables-balance-note-list',
  templateUrl: './receivables-balance-note-list.component.html',
  styleUrls: ['./receivables-balance-note-list.component.scss']
})
export class ReceivablesBalanceNoteListComponent implements OnDestroy, OnInit, AfterViewInit  {
  @Input() receivablesBalanceNote: Observable<ReceivablesBalanceNote[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  receivablesBalanceNoteDataSource: MatTableDataSource<ReceivablesBalanceNote> = new MatTableDataSource<ReceivablesBalanceNote>([]);
  displayedColumns: string[] = ['createdAt', 'note', 'user'];
  userPermissions: ReplaySubject<UserPermissions>;
  updateInProgress = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.receivablesBalanceNote
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((receivablesBalanceNote: ReceivablesBalanceNote[]) => this.receivablesBalanceNoteDataSource.data = receivablesBalanceNote);
  }


  ngAfterViewInit(): void {
    this.receivablesBalanceNoteDataSource.paginator = this.paginator;
  }

}
